import type { TShowToast } from '@/types/toasts'
import { useToastStore } from '@/stores/toast.store'

export const showToast: TShowToast = (message, type = 'info', configs) => {
  const toastStore = useToastStore()
  toastStore.showToast(message, type, configs)
}
